import React, { useRef } from "react";
import { Camera, X } from "lucide-react";

// Read a File -> downscaled JPEG base64 (keeps inspection payloads small).
async function fileToCompressedBase64(file, maxDim = 1600, quality = 0.7) {
  const dataUrl = await new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
  const img = await new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = dataUrl;
  });
  let { width, height } = img;
  if (width > maxDim || height > maxDim) {
    const scale = maxDim / Math.max(width, height);
    width = Math.round(width * scale);
    height = Math.round(height * scale);
  }
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  canvas.getContext("2d").drawImage(img, 0, 0, width, height);
  return canvas.toDataURL("image/jpeg", quality);
}

export function PhotoCapture({ photos = [], onChange, max = 8, testId }) {
  const inputRef = useRef(null);
  const add = async (e) => {
    const files = Array.from(e.target.files || []);
    const out = [...photos];
    for (const f of files) {
      if (out.length >= max) break;
      try { out.push(await fileToCompressedBase64(f)); } catch { /* skip bad file */ }
    }
    onChange(out);
    e.target.value = "";
  };
  const remove = (i) => onChange(photos.filter((_, idx) => idx !== i));

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {photos.map((p, i) => (
          <div key={i} className="relative h-20 w-20 overflow-hidden rounded-lg border border-slate-200">
            <img src={p} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => remove(i)} className="absolute right-0 top-0 rounded-bl bg-black/60 p-0.5 text-white" data-testid={`${testId}-remove-${i}`}>
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
        {photos.length < max && (
          <button type="button" onClick={() => inputRef.current?.click()} className="flex h-20 w-20 flex-col items-center justify-center rounded-lg border-2 border-dashed border-slate-300 text-slate-400 transition-colors hover:border-primary hover:text-primary" data-testid={testId}>
            <Camera className="h-5 w-5" />
            <span className="mt-1 text-[11px]">Add</span>
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" capture="environment" multiple={max > 1} className="hidden" onChange={add} />
    </div>
  );
}

export default PhotoCapture;
